import React, { useEffect, useState } from 'react';
import { ConnectionProfile, ProjectType } from 'nekst-api';
import { StagesToStatusListWidget } from './StagesToStatus';
import { Header3 } from 'ui-builder';
import FieldsMappingList from './FieldsMapping/FieldsMappingList';
import { PipelineMapping } from './PipelineMapping';
import { ProjectTypesTabs } from '../../shared/ProjectTypesTabs/ProjectTypesTabs';
import { AllTeamSetupAreasContext } from '../../markets/TeamSetupAreaContext';

export default function ProjectTypesConfiguration(
  props: {
    profile: ConnectionProfile,
  }
) {
  const [type, setType] = useState<ProjectType>(ProjectType.PENDING_BUYER);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const typeParam = urlParams.get('type');
    if (typeParam) {
      const projectType = typeParam as ProjectType;
      setType(projectType);
    }
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('type', type)
    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
  }, [type]);

  return (
    <>
      <Header3>Transaction Types Configuration</Header3>
      <ProjectTypesTabs setProjectType={setType} projectType={type} />
      <AllTeamSetupAreasContext>
        <PipelineMapping profile={props.profile} projectType={type} />
        <StagesToStatusListWidget profile={props.profile} projectType={type} />
        <FieldsMappingList profile={props.profile} projectType={type} />
      </AllTeamSetupAreasContext>
    </>
  );
}
